export const formatTimeMinutesHours = (time: number | string): string => {
    // If it's already a string, return it as-is
    if (typeof time === "string") {
        return time;
    }

    if (time < 60) {
        return `${time} min`;
    }

    const hours = Math.floor(time / 60);
    const minutes = time % 60;

    return `${hours} h${minutes > 0 ? ` ${minutes} min` : ""}`;
};
